import styled from 'styled-components';

import influencersGradientBg from 'src/images/svgs/campaigns/influencers/bg-gradient.svg';
import oldGradientBg from 'src/images/svgs/fireship/Bg_gradient.jpg';

export const StyledBar = styled.div<{ isEmbedded?: boolean; isGradient?: boolean; screenEmbedded?: boolean }>`
  position: relative;
  height: 6rem;
  width: ${({ screenEmbedded }) => (screenEmbedded ? 'auto' : '100%')};
  display: flex;
  gap: 3.2rem;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: ${({ screenEmbedded }) => (screenEmbedded ? '1rem 2rem' : '0')};
  border-radius: ${({ screenEmbedded }) => (screenEmbedded ? '5px' : '0')};

  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.offBlack};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 0;
  }

  ${({ isGradient }) =>
    isGradient
      ? `
      &:before {
        background-image: url(${oldGradientBg});
      }
    `
      : `
      &:before {
        background-image: url(${influencersGradientBg});
      }
    `}

  ${({ isEmbedded }) =>
    isEmbedded &&
    `
      &:before {
        background-image: none;
      }
    `}

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    height: auto;
    padding: 1.2rem;
    text-align: center;
  }

  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    letter-spacing: -0.03em;
    text-align: center;
    font-size: 2.2rem;
    margin: 0;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: 1rem;
    }
  }

  p span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  a {
    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const StyledCountdown = styled.div`
  z-index: 1;
`;

export const StyledCopyAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;

export const StyledCampaignPromotionText = styled.div`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-transform: uppercase;
  position: relative;
  z-index: 1;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 1rem;
  }

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const StyledCloseBtn = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  color: ${({ theme }) => theme.colors.grey[500]};
  cursor: pointer;

  svg {
    height: 2rem;
    width: 2rem;
  }
`;
